import React from 'react';
import Draggable from './Draggable.js';
import styleHelper from './../helpers/style';


/**
 * Drawer component
 * The top level component for the app
 * @class
 */
const Drawer = React.createClass({
  displayName: 'Drawer',
  dragStartPosition: 0,
  dragStopPosition: 0,
  dragging: false,
  toggling: false,


  propTypes: {
    axis: React.PropTypes.string.isRequired,
    bounds: React.PropTypes.object.isRequired,
    touch: React.PropTypes.bool,
    className: React.PropTypes.string,
    children: React.PropTypes.oneOfType([
      React.PropTypes.object,
      React.PropTypes.array,
    ]),
    supportsCssTransforms3d: React.PropTypes.bool,
    open: React.PropTypes.bool,
    closed: React.PropTypes.bool,
    openCallback: React.PropTypes.func,
    closeCallback: React.PropTypes.func,
    toggleOnClick: React.PropTypes.bool,
    preventDefaultEvents: React.PropTypes.bool,
  },


  /**
   * Get initial state object
   * @returns {Object} initial object
   */
  getInitialState() {
    return {
      initialPosition: {
        x: 0,
        y: 0,
      },
      open: this.props.open,
      closed: this.props.closed,
    };
  },


  /**
   * Called right before component mounts to DOM
   * @returns {undefined} undefined
   */
  componentDidMount() {
    const _this = this;

    setTimeout(function () {
      _this._setInitialPosition();
    }, 100);
  },


  /**
   * Renders component
   * @returns {ReactElement} A React element
   */
  render() {
    let className = 'component-drawer';
    const stateClassName = this.state.open ? ' open' : '';

    if (this.props.className) {
      className += (' ' + this.props.className);
    }

    className += stateClassName;

    return (React.createElement("div", {className: className}, 
      React.createElement(Draggable, {
        preventDefaultEvents: this.props.preventDefaultEvents, 
        initialPosition: this.state.initialPosition, 
        ref: 'draggable', 
        dragStartCallback: this._onDragStart, 
        dragStopCallback: this._onDragStop, 
        lock: this.props.axis, 
        bounds: this.props.bounds, 
        translate3d: this.props.supportsCssTransforms3d
      }, 
        React.createElement("div", {className: "content"}, 
          this.props.children
        )
      )
    ));
  },


  _setInitialPosition() {
    if (this.props.open) {
      this.setState({ open: true });
      this._open();
    } else if (this.props.closed) {
      this.setState({ open: false });
      this._close();
    }
  },


  /**
   * Handler for drag start
   * @param {Object} positionObject - An object containing the x and y positionObject
   * of the draggable content
   * @returns {undefined} undefined
   */
  _onDragStart(positionObject) {
    const noTransitionStyle = styleHelper.getTransitionDurationStyle('0ms');

    if (this.props.axis === 'x') {
      this.dragStartPosition = positionObject.x;
    }

    if (this.props.axis === 'y') {
      this.dragStartPosition = positionObject.y;
    }

    this.refs.draggable.setStyle(noTransitionStyle);
  },


  /**
   * Handler for drag stop
   * @param {Object} positionObject - An object containing the x and y positionObject
   * of the draggable content
   * @returns {undefined} undefined
   */
  _onDragStop(positionObject) {
    let dif;

    if (this.props.axis === 'x') {
      this.dragStopPosition = positionObject.x;
    }

    if (this.props.axis === 'y') {
      this.dragStopPosition = positionObject.y;
    }

    dif = this.dragStartPosition - this.dragStopPosition;
    if (dif < 0) {
      dif *= -1;
    }

    if (dif > 0) {
      if (this.props.axis === 'x') {
        if (this.dragStartPosition > this.dragStopPosition) {
          this._close();
        } else {
          this._open();
        }
      }

      if (this.props.axis === 'y') {
        if (this.dragStartPosition < this.dragStopPosition) {
          this._close();
        } else {
          this._open();
        }
      }
    } else {
      if (this.props.toggleOnClick) {
        this._toggle();
      }
    }
  },

  /**
   * Toggles the open/close states
   * @returns {undefined} undefined
   */
  _toggle() {
    if (!this.transitioning) {
      if (!this.state.open) {
        this.setState({ open: true });
        this._open();
      } else {
        this.setState({ open: false });
        this._close();
      }
    }
  },


  /**
   * Closes the drawer
   * @returns {undefined} undefined
   */
  _open() {
    const _this = this;
    const transitionStyle = styleHelper.getTransitionDurationStyle('500ms');
    let transformStyle;
    let newStyle;

    this.setState({ open: true });
    this.transitioning = true;

    if (this.props.axis === 'x') {
      transformStyle = styleHelper.getTranslateStyle(
        this.props.bounds.x2,
        0,
        0,
        this.props.supportsCssTransforms3d);
    }

    if (this.props.axis === 'y') {
      transformStyle = styleHelper.getTranslateStyle(
        0,
        this.props.bounds.y1,
        0,
        this.props.supportsCssTransforms3d);
    }

    newStyle = Object.assign(transformStyle, transitionStyle);
    this.refs.draggable.setStyle(newStyle);

    if (this.props.openCallback) {
      this.props.openCallback();
    }

    setTimeout(function () {
      _this.transitioning = false;
    }, 10);
  },


  /**
   * Opens the drawer
   * @returns {undefined} undefined
   */
  _close() {
    const _this = this;
    const transitionStyle = styleHelper.getTransitionDurationStyle('500ms');
    let transformStyle;
    let newStyle;

    this.setState({ open: false });
    this.transitioning = true;

    if (this.props.axis === 'x') {
      transformStyle = styleHelper.getTranslateStyle(
        this.props.bounds.x1,
        0,
        0,
        this.props.supportsCssTransforms3d);
    }

    if (this.props.axis === 'y') {
      transformStyle = styleHelper.getTranslateStyle(
        0,
        this.props.bounds.y2,
        0,
        this.props.supportsCssTransforms3d);
    }

    newStyle = Object.assign(transformStyle, transitionStyle);
    this.refs.draggable.setStyle(newStyle);

    if (this.props.closeCallback) {
      this.props.closeCallback();
    }

    setTimeout(function () {
      _this.transitioning = false;
    }, 10);
  },
});


export default Drawer;
